.atm_vy_1osqo2v{width:100%;}
.atm_9s_11p5wf0{display:grid;}
.atm_e0_1ghlemp.atm_e0_1ghlemp{grid-template-rows:1fr auto;}
.atm_dz_5bpdsk.atm_dz_5bpdsk{grid-template-columns:auto 1fr;}
.atm_l8_idpfg4{padding:0;}
.atm_cx_1cudcw5{gap:4px 8px;}
.atm_dy_1qimgpj.atm_dy_1qimgpj{grid-template-areas:'avatar content' 'empty meta';}
.atm_h_h9n0ih.atm_h_h9n0ih{align-items:end;}
.atm_h3_ftgil2.atm_h3_ftgil2{margin-top:8px;}
.atm_dz_1ghlemp.atm_dz_1ghlemp{grid-template-columns:1fr auto;}
.atm_dy_l68ngt.atm_dy_l68ngt{grid-template-areas:'content avatar' 'meta empty';}
.atm_9s_1txwivl{display:flex;}
.atm_ar_1bp4okc.atm_ar_1bp4okc{flex-direction:column;}
.atm_h_v2br90.atm_h_v2br90{align-items:start;}
.atm_cx_ftgil2{gap:8px;}
.atm_mk_h2mmj6{position:relative;}
.atm_d2_1edpjdk{grid-area:content;}
.atm_93kp19_1txwivl .bubbles-container{display:flex;}
.atm_1gkalst_1bp4okc.atm_1gkalst_1bp4okc .bubbles-container{flex-direction:column;}
.atm_1wrnu6x_1k6cvig .bubbles-container{max-width:min(95%, 600px);}
.atm_2udunt_ftgil2 .bubbles-container{gap:8px;}
.atm_1mt52k0_v2br90.atm_1mt52k0_v2br90 .bubbles-container{align-items:start;}
.atm_1mt52k0_h9n0ih.atm_1mt52k0_h9n0ih .bubbles-container{align-items:end;}
.atm_d2_8bpj96{grid-area:meta;}
.atm_h_1y6m0gg.atm_h_1y6m0gg{align-items:flex-start;}
.atm_1e8olkn_1txwivl .tags-container{display:flex;}
.atm_mcj83_vrvcex.atm_mcj83_vrvcex .tags-container{flex-direction:row;}
.atm_1y9pzsy_1g80g66.atm_1y9pzsy_1g80g66 .tags-container{flex-wrap:wrap;}
.atm_m82tpc_1y44olf.atm_m82tpc_1y44olf .tags-container{padding-bottom:4px;}
.atm_14i6wn6_1y6m0gg.atm_14i6wn6_1y6m0gg .tags-container{justify-content:flex-start;}
.atm_1d6y8nm_1y6m0gg.atm_1d6y8nm_1y6m0gg .tags-container{align-items:flex-start;}
.atm_1bb1ldo_ftgil2 .tags-container{gap:8px;}
.atm_yg25j5_1txwivl .meta-info-container{display:flex;}
.atm_1yju9ac_ftgil2 .meta-info-container{gap:8px;}
.atm_1wu4mge_1y6m0gg.atm_1wu4mge_1y6m0gg .meta-info-container{justify-content:flex-start;}
.atm_k5dmm5_1sbvcyy.atm_k5dmm5_1sbvcyy .meta-info-container{flex-direction:row-reverse;}
.atm_123djxa_1y44olf.atm_123djxa_1y44olf .meta-info-container{padding-bottom:4px;}
.atm_hwfq46_1txwivl .metadata-container{display:flex;}
.atm_1f4rs43_ftgil2 .metadata-container{gap:8px;}
.atm_h_esu3gu.atm_h_esu3gu{align-items:flex-end;}
.atm_14i6wn6_esu3gu.atm_14i6wn6_esu3gu .tags-container{justify-content:flex-end;}
.atm_1d6y8nm_esu3gu.atm_1d6y8nm_esu3gu .tags-container{align-items:flex-end;}
.atm_1wu4mge_esu3gu.atm_1wu4mge_esu3gu .meta-info-container{justify-content:flex-end;}
.atm_k5dmm5_vrvcex.atm_k5dmm5_vrvcex .meta-info-container{flex-direction:row;}
.atm_ge_glywfm.atm_ge_glywfm{list-style-type:none;}
.atm_cx_exct8b{gap:16px;}
.atm_5j_ftgil2{border-radius:8px;}
.atm_vv_6vc6lo{white-space:pre-line;}
.atm_vy_1ns9ob4{width:fit-content;}
.atm_3vvv9j_1osqo2v .img-bubble{width:100%;}
.atm_lixo4u_1w81w6r .img-bubble{min-height:150px;}
.atm_wz9o3w_118lp2q.atm_wz9o3w_118lp2q .img-bubble{background-color:#F4F5F7;}
.atm_11jrua9_ftgil2 .img-bubble{border-radius:8px;}
.atm_1vtj6rt_h2mmj6 .video-bubble-wrapper{position:relative;}
.atm_81na1h_1ulexfb .video-bubble-wrapper{display:block;}
.atm_1kh74zr_1osqo2v .video-bubble-wrapper{width:100%;}
.atm_rm8tbz_1kw7nm4 .video-bubble-wrapper{max-height:inherit;}
.atm_1slp5tf_ftgil2 .video-bubble-wrapper{border-radius:8px;}
.atm_1fvg8m3_15vqwwr .video-bubble-wrapper{overflow:hidden;}
.atm_1nq7lm4_tlke0l .video-bubble-wrapper{cursor:pointer;}
.atm_frn4w0_nb8q6m .video-bubble-wrapper:focus-visible{outline:2px solid #146EF5;}
.atm_140e372_yh40bf .video-bubble-wrapper:focus-visible{outline-offset:2px;}
.atm_10f50v_1ulexfb .video-bubble-video{display:block;}
.atm_10xh084_1osqo2v .video-bubble-video{width:100%;}
.atm_1ebvv1d_1wugsn5 .video-bubble-video{height:auto;}
.atm_1f57xij_1kw7nm4 .video-bubble-video{max-height:inherit;}
.atm_sfexbo_stnw88 .video-bubble-play{position:absolute;}
.atm_8hkxpd_1fwxnve .video-bubble-play{left:12px;}
.atm_1heg5ne_1fwxnve .video-bubble-play{bottom:12px;}
.atm_1anfm33_1ylpe5n .video-bubble-play{width:40px;}
.atm_26hra8_1ylpe5n .video-bubble-play{height:40px;}
.atm_coq5su_1txwivl .video-bubble-play{display:flex;}
.atm_104wt29_1h6ojuz.atm_104wt29_1h6ojuz .video-bubble-play{align-items:center;}
.atm_q0njiv_1h6ojuz.atm_q0njiv_1h6ojuz .video-bubble-play{justify-content:center;}
.atm_rq2bfs_1ssbidh .video-bubble-play{border-radius:50%;}
.atm_1hlusso_1f5m3fa.atm_1hlusso_1f5m3fa .video-bubble-play{background-color:rgba(0, 0, 0, 0.55);}
.atm_emeerz_1pec9uq .video-bubble-play{color:#ffffff;}
.atm_1dhkrso_glywfm .video-bubble-play{border:none;}
.atm_kuaf31_idpfg4 .video-bubble-play{padding:0;}
.atm_1nudofi_tlke0l .video-bubble-play{cursor:pointer;}
.atm_16l9syi_i96n7g .video-bubble-play{transition:background-color 0.15s ease;}
.atm_iqg4qf_1fk3lzb.atm_iqg4qf_1fk3lzb .video-bubble-play:hover,.atm_iqg4qf_1fk3lzb.atm_iqg4qf_1fk3lzb .video-bubble-play:focus-visible{background-color:rgba(0, 0, 0, 0.75);}
.atm_bgtar_nb8q6m .video-bubble-play:focus-visible{outline:2px solid #146EF5;}
.atm_ftkvjz_yh40bf .video-bubble-play:focus-visible{outline-offset:2px;}
.atm_1vm4k0c_1txwivl .pdf-bubble-wrapper{display:flex;}
.atm_k2jwgi_1bp4okc.atm_k2jwgi_1bp4okc .pdf-bubble-wrapper{flex-direction:column;}
.atm_arlajr_1osqo2v .pdf-bubble-wrapper{width:100%;}
.atm_192o_ftgil2 .pdf-bubble-wrapper{gap:8px;}
.atm_xkqb9h_h2mmj6 .pdf-bubble-preview{position:relative;}
.atm_133sylk_1osqo2v .pdf-bubble-preview{width:100%;}
.atm_1dxu9p8_1hh4adr .pdf-bubble-preview{aspect-ratio:8.5/11;}
.atm_jauuyv_qcxa0d .pdf-bubble-preview{max-height:320px;}
.atm_1vxljc1_1pec9uq.atm_1vxljc1_1pec9uq .pdf-bubble-preview{background-color:#ffffff;}
.atm_ayc8nm_15vqwwr .pdf-bubble-preview{overflow:hidden;}
.atm_7exy08_tlke0l .pdf-bubble-preview{cursor:pointer;}
.atm_n51wu_nb8q6m .pdf-bubble-preview:focus-visible{outline:2px solid #146EF5;}
.atm_r3a6im_yh40bf .pdf-bubble-preview:focus-visible{outline-offset:2px;}
.atm_1rb4we0_stnw88 .pdf-bubble-preview-object{position:absolute;}
.atm_1hfuss6_1228ahe .pdf-bubble-preview-object{top:-4%;}
.atm_1qt05d9_1228ahe .pdf-bubble-preview-object{left:-4%;}
.atm_1m7xmw4_15bf4ue .pdf-bubble-preview-object{width:108%;}
.atm_8eecar_15bf4ue .pdf-bubble-preview-object{height:108%;}
.atm_108vm8a_glywfm .pdf-bubble-preview-object{border:none;}
.atm_1e6rvo7_glywfm .pdf-bubble-preview-object{pointer-events:none;}
.atm_bfik4h_1pec9uq.atm_bfik4h_1pec9uq .pdf-bubble-preview-object{background-color:#ffffff;}
.atm_1xk4252_stnw88 .pdf-bubble-preview-overlay{position:absolute;}
.atm_1vyab02_idpfg4 .pdf-bubble-preview-overlay{inset:0;}
.atm_p5towi_1j28jx2 .pdf-bubble-preview-overlay{background:transparent;}
.atm_4ya2ig_1txwivl .pdf-bubble{display:flex;}
.atm_ibyfhr_1h6ojuz.atm_ibyfhr_1h6ojuz .pdf-bubble{align-items:center;}
.atm_1ri9ht7_1fwxnve .pdf-bubble{gap:12px;}
.atm_pkc8it_ftgil2 .pdf-bubble{padding:8px;}
.atm_bdtlxm_1osqo2v .pdf-bubble{width:100%;}
.atm_96iw1k_1osqo2v .pdf-bubble{max-width:100%;}
.atm_ibzrap_usvi9m .pdf-bubble{box-sizing:border-box;}
.atm_1eqlpfb_1j28jx2 .pdf-bubble{background:transparent;}
.atm_eqafc4_glywfm .pdf-bubble{border:none;}
.atm_saz9z8_1y44olf .pdf-bubble{border-radius:4px;}
.atm_1a1107_tlke0l .pdf-bubble{cursor:pointer;}
.atm_1vwqn5e_1e5hqsa .pdf-bubble{text-align:left;}
.atm_ga4918_nb8q6m .pdf-bubble:focus-visible{outline:2px solid #146EF5;}
.atm_1a60abi_yh40bf .pdf-bubble:focus-visible{outline-offset:2px;}
.atm_1s1mos0_h2mmj6 .pdf-bubble-icon{position:relative;}
.atm_8n18mt_idpfg4.atm_8n18mt_idpfg4 .pdf-bubble-icon{flex-shrink:0;}
.atm_17b3xj1_1vi7ecw .pdf-bubble-icon{width:32px;}
.atm_3an2z9_1ylpe5n .pdf-bubble-icon{height:40px;}
.atm_q6k6fx_1pec9uq .pdf-bubble-icon{color:#ffffff;}
.atm_jtl91d_xyes15 .pdf-bubble-icon{filter:drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15)) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));}
.atm_1vstip6_stnw88 .pdf-bubble-icon-shape{position:absolute;}
.atm_1chblre_idpfg4 .pdf-bubble-icon-shape{inset:0;}
.atm_1ch19ob_1ulexfb .pdf-bubble-icon-shape{display:block;}
.atm_rry1mv_stnw88 .pdf-bubble-badge{position:absolute;}
.atm_1m15px8_1nrftia .pdf-bubble-badge{top:60%;}
.atm_1hb2v9g_1ssbidh .pdf-bubble-badge{left:50%;}
.atm_7agurk_1ooetej .pdf-bubble-badge{transform:translate(-50%, -50%);}
.atm_1e40ll3_19bvopo.atm_1e40ll3_19bvopo .pdf-bubble-badge{font-size:10px;}
.atm_1d6sfzq_1fw03zg.atm_1d6sfzq_1fw03zg .pdf-bubble-badge{font-weight:700;}
.atm_1bb4ykf_kb7nvz.atm_1bb4ykf_kb7nvz .pdf-bubble-badge{line-height:1;}
.atm_h95ghd_wh2yj2 .pdf-bubble-badge{letter-spacing:0.5px;}
.atm_18x0qvj_1aemfod .pdf-bubble-badge{color:#146EF5;}
.atm_uh78pz_glywfm .pdf-bubble-badge{pointer-events:none;}
.atm_1nmr8wh_xi18ig .pdf-bubble-info{flex:1 0 0;}
.atm_124gksy_idpfg4 .pdf-bubble-info{min-width:0;}
.atm_499ar4_1txwivl .pdf-bubble-info{display:flex;}
.atm_1qdfwuu_1bp4okc.atm_1qdfwuu_1bp4okc .pdf-bubble-info{flex-direction:column;}
.atm_1yeiqgd_1y44olf .pdf-bubble-info{gap:4px;}
.atm_1lnb1it_15vqwwr .pdf-bubble-filename{overflow:hidden;}
.atm_nb0or7_1l2sidv .pdf-bubble-filename{text-overflow:ellipsis;}
.atm_1kdqwuq_1q9ccgz .pdf-bubble-filename{white-space:nowrap;}
.atm_cg8gdz_idpfg4 .pdf-bubble-filename{margin:0;}
.atm_15rqs9i_idpfg4 .pdf-bubble-filesize{margin:0;}
.atm_1tt1sb2_1byrjjm.atm_1tt1sb2_1byrjjm .pdf-bubble:hover,.atm_1tt1sb2_1byrjjm.atm_1tt1sb2_1byrjjm .pdf-bubble:focus-visible{background-color:#E7EBEE;}
.atm_1tt1sb2_1c5q7hc.atm_1tt1sb2_1c5q7hc .pdf-bubble:hover,.atm_1tt1sb2_1c5q7hc.atm_1tt1sb2_1c5q7hc .pdf-bubble:focus-visible{background-color:#DCEBFE;}
.atm_6h_t94yts.atm_6h_t94yts{border-width:1px;}
.atm_66_nqa18y.atm_66_nqa18y{border-style:solid;}
.atm_4b_j1e0tf.atm_4b_j1e0tf{border-color:#CED3DA;}
.atm_5j_1y44olf{border-radius:4px;}
.atm_70_1oy2gec{box-shadow:0px 1px 1px 0px rgba(0, 33, 82, 0.15),0px 1px 3px 1px rgba(0, 33, 82, 0.15);}
.atm_mk_stnw88{position:absolute;}
.atm_tk_4h84z3{top:-16px;}
.atm_2d_1pec9uq.atm_2d_1pec9uq{background-color:#ffffff;}
.atm_wq_jbo96x{z-index:100000;}
.atm_lo_yh40bf.atm_lo_yh40bf{padding-top:2px;}
.atm_ll_yh40bf.atm_ll_yh40bf{padding-right:2px;}
.atm_le_yh40bf.atm_le_yh40bf{padding-bottom:2px;}
.atm_lk_yh40bf.atm_lk_yh40bf{padding-left:2px;}
.atm_1cwid8j_1y44olf.atm_1cwid8j_1y44olf button{padding-top:4px;}
.atm_1mqt8pr_1y44olf.atm_1mqt8pr_1y44olf button{padding-right:4px;}
.atm_epq1wf_1y44olf.atm_epq1wf_1y44olf button{padding-bottom:4px;}
.atm_1sqqcsc_1y44olf.atm_1sqqcsc_1y44olf button{padding-left:4px;}
.atm_1cmj5ue_n7od8j button{height:unset;}
.atm_lo_idpfg4.atm_lo_idpfg4{padding-top:0;}
.atm_ll_idpfg4.atm_ll_idpfg4{padding-right:0;}
.atm_le_idpfg4.atm_le_idpfg4{padding-bottom:0;}
.atm_lk_idpfg4.atm_lk_idpfg4{padding-left:0;}
.atm_j3_n7od8j{max-width:unset;}
.atm_l0_ewfl5b.atm_l0_ewfl5b{overflow-x:visible;}
.atm_l1_ewfl5b.atm_l1_ewfl5b{overflow-y:visible;}
.atm_14i5by5_idpfg4.atm_14i5by5_idpfg4 .wv-modal-flex-content{padding-top:0;}
.atm_14ocx76_idpfg4.atm_14ocx76_idpfg4 .wv-modal-flex-content{padding-right:0;}
.atm_1rv9teg_idpfg4.atm_1rv9teg_idpfg4 .wv-modal-flex-content{padding-bottom:0;}
.atm_12q8lwd_idpfg4.atm_12q8lwd_idpfg4 .wv-modal-flex-content{padding-left:0;}
.atm_iuvhxz_14b1je0 .wv-modal-flex-content{max-height:78vh;}
.atm_13u4jmp_1kw7nm4 img{max-height:inherit;}
.atm_1th6i68_stnw88 .btn-containers{position:absolute;}
.atm_1japuz7_1txwivl .btn-containers{display:flex;}
.atm_1lyraix_ftgil2 .btn-containers{gap:8px;}
.atm_8xl925_rryus5 .btn-containers{top:-32px;}
.atm_mcmc7t_idpfg4 .btn-containers{right:0;}
.atm_7gnc60_1pec9uq.atm_7gnc60_1pec9uq .download-button{background-color:#ffffff;}
.atm_1uqfxas_1tcgj5g .download-button{height:24px;}
.atm_dhrnrb_1tcgj5g .download-button{width:24px;}
.atm_1yce1vv_idpfg4.atm_1yce1vv_idpfg4 .download-button{padding-top:0;}
.atm_1vwpm6x_idpfg4.atm_1vwpm6x_idpfg4 .download-button{padding-right:0;}
.atm_uhtyhf_idpfg4.atm_uhtyhf_idpfg4 .download-button{padding-bottom:0;}
.atm_1kxfmy8_idpfg4.atm_1kxfmy8_idpfg4 .download-button{padding-left:0;}
.atm_1whzjhj_1pec9uq.atm_1whzjhj_1pec9uq .close-button{background-color:#ffffff;}
.atm_it73ya_1tcgj5g .close-button{height:24px;}
.atm_exw26n_1tcgj5g .close-button{width:24px;}
.atm_zpzzaw_idpfg4.atm_zpzzaw_idpfg4 .close-button{padding-top:0;}
.atm_d0yz3_idpfg4.atm_d0yz3_idpfg4 .close-button{padding-right:0;}
.atm_lis90x_idpfg4.atm_lis90x_idpfg4 .close-button{padding-bottom:0;}
.atm_hp1agh_idpfg4.atm_hp1agh_idpfg4 .close-button{padding-left:0;}
